import { mode, StyleFunctionProps } from '@chakra-ui/theme-tools';

const baseStyleOverlay = {
  bg: 'blackAlpha.500',
};

const baseStyleDialogContainer = ({ size }: StyleFunctionProps) => ({
  px: size === 'full' ? 0 : 4,
});

function baseStyleDialog(props: StyleFunctionProps) {
  return {
    bg: mode('white', 'gray.700')(props),
    boxShadow: mode('lg', 'dark-lg')(props),
    py: { base: 6, md: 8 },
    ...(props.size === 'full'
      ? { my: '0', borderRadius: '0' }
      : { my: '3.75rem', borderRadius: '2xl' }),
  };
}

const baseStyleFooter = {
  px: { base: 6, md: 8 },
  pb: 0,
  pt: 4,
};
const baseStyleHeader = {
  fontSize: '2xl',
  fontWeight: 'extrabold',
  px: { base: 6, md: 8 },
  pb: 0,
  pt: 0,
};

function baseStyleBody() {
  return {
    px: { base: 6, md: 8 },
    py: 0,
  };
}

const baseStyle = (props: StyleFunctionProps) => ({
  overlay: baseStyleOverlay,
  dialogContainer: baseStyleDialogContainer(props),
  dialog: baseStyleDialog(props),
  header: baseStyleHeader,
  body: baseStyleBody(),
  footer: baseStyleFooter,
});

const defaultProps = {
  size: 'md',
};

export default {
  baseStyle,
  defaultProps,
};
